/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserVatListDtoController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		VatFactory,
		UserVatListDtoSearchFactory
	) {
		$scope.vatList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.paging = {};
		$scope.paging.page = 1;
		$scope.totalCountIsKnownAtTheMoment = false;

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeVat)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeVat);
		} else {
			$scope.pageSize = 20;

			$rootScope.pageSizeVat = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('user-vat.new');
		};

		$scope.getVatList = function() {
			UserVatListDtoSearchFactory.query(
				{
					page: $scope.paging.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.vatList = result.items;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getVatList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};

		$scope.updateVatTypeUISelect = function(item, model) {
			$scope.search();
		};
	});
